<script setup>
import {ref, watch, toRaw} from 'vue'
import {useCollectionFiltersStore} from '@/stores/collectionFilters'

// Component Imports
import CollectionFilterFieldsMenu from "./CollectionFilterFieldsMenu.vue"
import CollectionFilterOperatorMenu from "./CollectionFilterOperatorMenu.vue"
import CollectionFilterControl from "./CollectionFilterControl.vue"
import Button from '@/common/Button.vue'

const props = defineProps({
    contentId: Number,
    item: Object,
})

const collectionFiltersStore = useCollectionFiltersStore()

// Helper to safely deep clone a Vue prop/reactive object
const clone = (val) => val ? structuredClone(toRaw(val)) : null

// State: Store a copy of the item to track changes
const oldItem = ref(clone(props.item))

// Watcher: Deep watch the item prop to sync with store
watch(
    () => props.item,
    (newValue) => {
        collectionFiltersStore.updateItem({
            item: newValue,
            oldItem: oldItem.value
        })

        // Retain a copy of the object for the next change reference
        oldItem.value = clone(newValue)
    },
    {deep: true}
)

// Methods
const deleteFilter = (filterId) => {
    collectionFiltersStore.deleteFilter({
        filterId: filterId,
        contentId: props.contentId
    })
}
</script>

<template>
    <div class="d-flex align-items-start">
        <div class="flex-fill d-flex flex-wrap align-items-center">
            <CollectionFilterFieldsMenu
                :content-id="contentId"
                :item="item"
                class="me-1 mb-1"
            />

            <CollectionFilterOperatorMenu
                :content-id="contentId"
                :item="item"
                class="me-1 mb-1"
            />

            <CollectionFilterControl
                v-if="item.operator !== ''"
                :item="item"
                class="mb-1"
            />
        </div>

        <Button @click="deleteFilter(item.id)" class="btn-sm">
            <i class="bi-trash3"/>
        </Button>
    </div>
</template>